export const getColor = (color: string) => {
  switch (color) {
    case 'preorder':
      return 'orange';
    case 'cancelled':
      return 'red';
    case 'active':
      return 'blue';
    case 'finished':
      return 'green';
    case 'active':
      return 'blue';

    default:
      return 'black';
  }
};
